import { render, staticRenderFns } from "./membershipfees.vue?vue&type=template&id=64d58bc4"
import script from "./membershipfees.vue?vue&type=script&lang=js"
export * from "./membershipfees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports